export default __webpack_public_path__ + "static/media/me-icon-active.3e711ba6.webp";